const config = {
    "urlJsonPublications": process.env.REACT_APP_URLJSON,
    "api_html5": process.env.REACT_APP_API_URL_HTML5,
    "env": process.env.REACT_APP_AMBIENTE,
    "urlSupport": "https://academy.virtualpro.co/",
    "urlImgsTrivias": process.env.REACT_APP_URL_IMGS_TRIVIAS
}

export { config };